import { FC, FormEvent } from 'react';
import { formOptions } from '@tanstack/react-form';
import { useAppForm } from '@new/common/hooks/form';

type EmailFormFields = 'currentEmail' | 'newEmail';

const EMAIL_FIELDS: { name: EmailFormFields; label: string; placeholder: string }[] = [
  { name: 'currentEmail', label: 'Current Email', placeholder: 'Current Email' },
  { name: 'newEmail', label: 'New Email', placeholder: 'Enter new email address' },
];

interface EmailSettingsFormProps {
  user: User;
}

const emailSettingsFormOpts = formOptions({
  defaultValues: {
    currentEmail: '',
    newEmail: '',
    password: '',
  },
});

export const EmailSettingsForm: FC<EmailSettingsFormProps> = ({ user }) => {
  const form = useAppForm({
    ...emailSettingsFormOpts,
    defaultValues: {
      currentEmail: user.email || '',
      newEmail: '',
      password: '',
    },
    validators: {
      onSubmit: () => {
        return undefined;
      },
    },
  });

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    form.handleSubmit();
  };

  return (
    <form onSubmit={onSubmit} className="flex flex-col gap-5">
      {EMAIL_FIELDS.map(({ name, label, placeholder }) => (
        <form.AppField
          key={name}
          name={name}
          children={(field) => <field.Email label={label} placeholder={placeholder} disabled />}
        />
      ))}

      <form.AppField
        name="password"
        children={(field) => (
          <field.Password label="Password" placeholder="Enter your password to confirm" disabled />
        )}
      />

      <form.AppForm>
        <form.SubmitButton label="Save changes" />
      </form.AppForm>
    </form>
  );
};
